import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { TextField, Button, InputLabel, Tooltip } from "@mui/material";
import Header from "../header/Header";
import { useNavigate, useParams } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import axios from "axios";
import { toast } from "react-toastify";
import useToast from "../../hooks/useToast";
import { phone } from "phone";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const AdditionalInformation = () => {
  const navigate = useNavigate();
  const {eventId} = useParams();
  const token = localStorage.getItem("token");
  const toastOptions = useToast();

  const initialValues = {
    event_id: eventId,
    accessibility_info: "",
    health_safety_guidelines: "",
    food_beverage_options: "",
    parking_info: "",
    public_transportation: "",
    merchandise_info: "",
    volunteer_opportunities: "",
    contact_info: "",
  };
  const phoneNumberRegex = /^[+]?[1-9]\d{1,14}$/;

  const validationSchema = Yup.object({
    accessibility_info: Yup.string(),
    health_safety_guidelines: Yup.string(),
    food_beverage_options: Yup.string(),
    parking_info: Yup.string(),
    public_transportation: Yup.string(),
    merchandise_info: Yup.string(),
    volunteer_opportunities: Yup.string(),
    contact_info: Yup.string()
      .matches(phoneNumberRegex, "Invalid phone number format"),
  });

  const handlePhoneChange = (value, country, setFieldValue) => {
    setFieldValue("contact_info", value);
    // initialValues.contact_info = value;
    // initialValues.country_code = country.dialCode;
  };

  const handleSubmit = async (values) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/v1/admin/additional/save`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message, toastOptions);
      setTimeout(() => {
        navigate(`/events`);
      });
      // Remove multiple items from localStorage
      localStorage.removeItem("lineupId");
      localStorage.removeItem("marketingId");
      localStorage.removeItem("ticketId");
    } catch (error) {
      console.log(error);
      toast.error("Error Creating Additional Information", toastOptions);
    }
  };

  return (
    <>
      <Header />
      <div className="container">
        <h2 className="mt-4">Additional Information</h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}



          
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 pb-4">
                  <InputLabel htmlFor="accessibility_info">
                    Accessibility Information
                    <Tooltip title="Details on how the event accommodates people with disabilities">
                      <InfoIcon
                        style={{ marginLeft: "8px", fontSize: "16px" }}
                      />
                    </Tooltip>
                  </InputLabel>
                  <TextField
                    id="accessibility_info"
                    name="accessibility_info"
                    variant="outlined"
                    fullWidth
                    value={values.accessibility_info}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.accessibility_info && !!errors.accessibility_info
                    }
                    helperText={
                      touched.accessibility_info && errors.accessibility_info
                    }
                  />
                </div>

                <div className="col-md-6 pb-4">
                  <InputLabel htmlFor="health_safety_guidelines">
                    Health and Safety Guidelines
                    <Tooltip title="COVID-19 protocols, first aid stations, security measures">
                      <InfoIcon
                        style={{ marginLeft: "8px", fontSize: "16px" }}
                      />
                    </Tooltip>
                  </InputLabel>
                  <TextField
                    id="health_safety_guidelines"
                    name="health_safety_guidelines"
                    variant="outlined"
                    fullWidth
                    value={values.health_safety_guidelines}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.health_safety_guidelines &&
                      !!errors.health_safety_guidelines
                    }
                    helperText={
                      touched.health_safety_guidelines &&
                      errors.health_safety_guidelines
                    }
                  />
                </div>

                <div className="col-md-6 pb-4">
                  <InputLabel htmlFor="food_beverage_options">
                    Food and Beverage Options
                    <Tooltip title="Information on vendors, types of food and drinks available">
                      <InfoIcon
                        style={{ marginLeft: "8px", fontSize: "16px" }}
                      />
                    </Tooltip>
                  </InputLabel>
                  <TextField
                    id="food_beverage_options"
                    name="food_beverage_options"
                    variant="outlined"
                    fullWidth
                    value={values.food_beverage_options}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.food_beverage_options &&
                      !!errors.food_beverage_options
                    }
                    helperText={
                      touched.food_beverage_options &&
                      errors.food_beverage_options
                    }
                  />
                </div>

                <div className="col-md-6 pb-4">
                  <InputLabel htmlFor="parking_info">
                    Parking Information
                    <Tooltip title="Details on parking availability, costs, and locations">
                      <InfoIcon
                        style={{ marginLeft: "8px", fontSize: "16px" }}
                      />
                    </Tooltip>
                  </InputLabel>
                  <TextField
                    id="parking_info"
                    name="parking_info"
                    variant="outlined"
                    fullWidth
                    value={values.parking_info}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.parking_info && !!errors.parking_info}
                    helperText={touched.parking_info && errors.parking_info}
                  />
                </div>

                <div className="col-md-6 pb-4">
                  <InputLabel htmlFor="public_transportation">
                    Public Transportation Options
                    <Tooltip title="Information on nearby public transport and shuttle services">
                      <InfoIcon
                        style={{ marginLeft: "8px", fontSize: "16px" }}
                      />
                    </Tooltip>
                  </InputLabel>
                  <TextField
                    id="public_transportation"
                    name="public_transportation"
                    variant="outlined"
                    fullWidth
                    value={values.public_transportation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.public_transportation &&
                      !!errors.public_transportation
                    }
                    helperText={
                      touched.public_transportation &&
                      errors.public_transportation
                    }
                  />
                </div>

                <div className="col-md-6 pb-4">
                  <InputLabel htmlFor="merchandise_info">
                    Merchandise Information
                    <Tooltip title="Details on event merchandise and where it can be purchased">
                      <InfoIcon
                        style={{ marginLeft: "8px", fontSize: "16px" }}
                      />
                    </Tooltip>
                  </InputLabel>
                  <TextField
                    id="merchandise_info"
                    name="merchandise_info"
                    variant="outlined"
                    fullWidth
                    value={values.merchandise_info}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.merchandise_info && !!errors.merchandise_info
                    }
                    helperText={
                      touched.merchandise_info && errors.merchandise_info
                    }
                  />
                </div>

                <div className="col-md-6 pb-4">
                  <InputLabel htmlFor="volunteer_opportunities">
                    Volunteer Opportunities
                    <Tooltip title="Information on how people can volunteer and what roles are available">
                      <InfoIcon
                        style={{ marginLeft: "8px", fontSize: "16px" }}
                      />
                    </Tooltip>
                  </InputLabel>
                  <TextField
                    id="volunteer_opportunities"
                    name="volunteer_opportunities"
                    variant="outlined"
                    fullWidth
                    value={values.volunteer_opportunities}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.volunteer_opportunities &&
                      !!errors.volunteer_opportunities
                    }
                    helperText={
                      touched.volunteer_opportunities &&
                      errors.volunteer_opportunities
                    }
                  />
                </div>

                <div className="col-md-6 pb-4">
                  <InputLabel htmlFor="contact_info">
                    Contact Information
                    <Tooltip title="For event inquiries, support, and more">
                      <InfoIcon
                        style={{ marginLeft: "8px", fontSize: "16px" }}
                      />
                    </Tooltip>
                  </InputLabel>
                  <PhoneInput
                    name="contact_info"
                    // country={values.country_code || "us"}
                    value={values.contact_info}
                    onChange={(value, country) =>
                      handlePhoneChange(value, country, setFieldValue)
                    }
                    inputStyle={{
                      width: "100%",
                      height: "40px",
                    }}
                  />
                  {touched.contact_info && errors.contact_info && (
                    <small className="text-danger">{errors.contact_info}</small>
                  )}
                </div>

                <div className="col-md-12 d-flex justify-content-end mt-4">
                  <Button
                    variant="outlined"
                    color="secondary"
                    type="button"
                    className="btn cancel"
                    onClick={() => {
                      navigate(`/event-information/${eventId}`);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    className="ml-2 btn submit"
                  >
                    Save
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AdditionalInformation;
